import {twMerge} from '@sdox/utils'

import {KpiItem} from './Item'

import type {KpiItemBaseProps} from './Item'
import type {ComponentProps} from 'react'

export interface KpiGridProps extends ComponentProps<'div'> {
  items: KpiItemBaseProps[]
  visualization?: 'DEFAULT' | 'UNDERLINE'
}

export const KpiGrid = ({items = [], className, visualization = 'DEFAULT', ...restProps}: KpiGridProps) => (
  <div className={'@container/block'}>
    <div
      className={twMerge(
        'grid w-full grid-cols-1 gap-spacing-48',
        '@[380px]:grid-cols-2 @[380px]:gap-block-medium @[750px]:grid-cols-3',
        className,
      )}
      {...restProps}
    >
      {items.map((item, index) => (
        <KpiItem
          key={index}
          {...item}
          visualization={visualization}
        />
      ))}
    </div>
  </div>
)
